import { Components } from "@mui/material/styles";

export const MuiTooltip: Components['MuiTooltip'] = {
    defaultProps: {
        arrow: true
    },
    styleOverrides: {
        tooltip: {
            backgroundColor: "#005075",
            fontSize: "12px",
            color: "#FFFFFF",
            letterSpacing: "0",
            textAlign: "center",
            lineHeight: "12px",
            fontFamily: "Roboto",
            fontWeight: 500,
            borderRadius: "2px",
            padding: "6px 8px",
            'span': {
                color: "#005075",
            }
        }
    }
};
